import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
    { label: "About", href: "#about", id: "01" },
    { label: "Mission", href: "#mission", id: "02" },
    { label: "Impact", href: "#impact", id: "03" },
    { label: "Ventures", href: "#ventures", id: "04" },
    { label: "Services", href: "#services", id: "05" },
    { label: "Awards", href: "#awards", id: "06" },
    { label: "Locations", href: "#locations", id: "07" },
    { label: "Gallery", href: "#gallery", id: "08" },
    { label: "Contact", href: "#contact", id: "09" },
];

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-paper-50/85 border-b border-ink-900/10 shadow-[0_1px_0_rgba(14,77,146,0.05)]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
                <a href="#top" data-testid="navbar-logo" className="flex items-baseline gap-2 group shrink-0">
                    <span className="font-display text-xl xl:text-2xl tracking-tight text-ink-900 italic whitespace-nowrap">
                        Dr. Rahul Ghule
                    </span>
                    <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-bisleri group-hover:tracking-[0.35em] transition-all whitespace-nowrap">
                        / MBBS
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-4 xl:gap-6">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.id}
                            href={link.href}
                            data-testid={`nav-link-${link.label.toLowerCase()}`}
                            className="group flex items-baseline gap-1.5 text-ink-700 hover:text-bisleri transition-colors"
                        >
                            <span className="font-mono text-[10px] text-ink-500 group-hover:text-clinicgreen-deep transition-colors">
                                {link.id}
                            </span>
                            <span className="font-body text-sm tracking-wide link-underline">
                                {link.label}
                            </span>
                        </a>
                    ))}
                </nav>

                <a
                    href="#contact"
                    data-testid="navbar-cta"
                    className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 bg-bisleri text-white hover:bg-bisleri-deep transition-all duration-300 font-mono text-[11px] tracking-[0.2em] uppercase rounded-sm"
                >
                    Connect
                </a>

                <button
                    aria-label="Toggle menu"
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    className="lg:hidden text-ink-900"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="lg:hidden bg-paper-50/98 backdrop-blur-xl border-t border-ink-900/10">
                    <div className="px-6 py-8 flex flex-col gap-5">
                        {NAV_LINKS.map((link) => (
                            <a
                                key={link.id}
                                href={link.href}
                                onClick={() => setOpen(false)}
                                className="flex items-baseline gap-3 text-ink-800 hover:text-bisleri"
                            >
                                <span className="font-mono text-[10px] text-ink-500">{link.id}</span>
                                <span className="font-display text-2xl">{link.label}</span>
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
